import lazy from 'utils/lazy';

export const Catalog = lazy(() => import('./Catalog'));
